import React from "react";
import { FaClipboard, FaClipboardCheck } from "react-icons/fa";

type Props = {
    value: string | any
}

export default function CopyButton({ value }: Props) {
  let [copied, setCopied] = React.useState(false);

  React.useEffect(() => {
    if (copied) {
      let id = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(id);
    }
  }, [copied]);

  return (
    <button
      className="m-4 rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
      title="Copy entire script to clipboard"
      onClick={() => {
        navigator.clipboard.writeText(value).catch(err => console.error(err));
        setCopied(true);
      }}
    >

      {copied ? <span><FaClipboardCheck className="float-left m-1 mr-2" />Copied!</span> : <span><FaClipboard className="float-left m-1 mr-2" />Copy Script</span>}
      {/* {copied ? <FaClipboardCheck /> :<FaClipboard className="" />} */}
    </button>
  );
}

